// extracted by mini-css-extract-plugin
module.exports = {"partners-slider":"partners-slider","partnersSlider":"partners-slider","slick-slide":"slick-slide","slickSlide":"slick-slide","slick-track":"slick-track","slickTrack":"slick-track"};